import __request__ from "routing/request";
export function displayGettingStarted() {
  return __request__("GET", "/system/gettingstarted", null, {}, {
    "Accept": ["application/json"]
  });
}
export function dismissGettingStarted() {
  return __request__("POST", "/system/gettingstarted/dismiss", null, {}, {
    "Accept": ["application/json"]
  });
}
